<template lang="pug">
  transition(name="slide")
    .box.pt-2.filter-wrapper(:class="{'is-active': display.filters, 'is-inactive': !display.filters}")
      h3.mb-2.has-text-left.has-text-weight-bold.is-flex.has-aligned-center
        span Filters
        div.ml-auto
          button.button.is-white.button-toggle-filters(@click="toggleFilter()")
            b-icon(icon="filter-list" :class="{'has-text-primary': display.filters}")
      // POS
      .columns.has-aligned-center.filter.filter-pos
        .column.is-wide
          b-field
            b-input.is-wide(
              icon="search"
              type="search"
              placeholder="Search"
              @change.native="trottledSearch"
              @keyup.native="trottledSearch"
              v-model="search"
              )
            p.control.is-hidden-mobile
              span.button.is-light
                b-checkbox.is-small(v-model="filters.options.searchStartsWith") Starts with
                b-checkbox.is-small(v-model="filters.options.searchEndsWith") Ends with
                <!--b-checkbox.is-small(v-model="filters.options.withVideoOnly") Has video-->

      .columns.filter.filter-pos.has-flex-start-items.has-flex-wrap
        // POS
        .column.has-flex-wrap.is-12-mobile
          b-dropdown.card.w-100(
            :hoverable="hoverable"
            :open="false"
          )
            .card-header.w-100(
              slot="trigger"
              )
              p.card-header-title(:class="{'has-text-info': activePos.length}")
                b-icon(icon="label")
                span Part of Speech
              a.card-header-icon(@click="")
                b-icon(
                  icon="arrow-drop-down"
                  )

            .card-content
              .content
                .is-flex.has-text-right.has-flex-wrap
                  button.button.is-fullwidth.is-small.mb-1(
                    :class="{'is-info': filters.pos[short]}"
                    @click="toggleDeep('pos', short)"
                    v-for="(pos, short) of pos"
                  ) {{ pos }}

        // PHONEME
        .column.has-flex-wrap.is-12-mobile
          b-dropdown.card.w-100(
            :hoverable="hoverable"
            :open="false"
          )
            .card-header(
            slot="trigger"
            )
              p.card-header-title(:class="{'has-text-info': activePhonemes.length}")
                b-icon(icon="surround-sound")
                span Phonemes
              a.card-header-icon
                b-icon(
                icon="arrow-drop-down"
                )

            .card-content
              .content
                h5.is-size-7.mb-1.has-text-left Consonants
                .is-flex.has-flex-wrap.has-sb
                  button.button.is-small.mb-1(
                  :class="{'is-info': filters.phonemes[consonant]}"
                  @click="toggleDeep('phonemes', consonant)"
                  v-for="consonant in phonemes.consonants"
                  ) {{ consonant }}
                h5.is-size-7.mb-1.mt-2.has-text-left Simple vowels
                .is-flex.has-flex-wrap.has-sb
                  button.button.is-small.mb-1(
                  :class="{'is-info': filters.phonemes[vowel]}"
                  @click="toggleDeep('phonemes', vowel)"
                  v-for="vowel in phonemes.simple_vowels"
                  ) {{ vowel }}
                h5.is-size-7.mb-1.mt-2.has-text-left Diphthongs
                .is-flex.has-flex-wrap.has-sb
                  button.button.is-small.mb-1(
                  :class="{'is-info': filters.phonemes[vowel]}"
                  @click="toggleDeep('phonemes', vowel)"
                  v-for="vowel in phonemes.diphthongs_vowels"
                  ) {{ vowel }}

        // STRESS PATTERNS
        .column.has-flex-wrap.stress-pattern.is-12-mobile
          b-dropdown.card.w-100(
            :hoverable="hoverable"
            :open="false"
          )
            .card-header(
            slot="trigger"
            )
              p.card-header-title(:class="{'has-text-info': stressPatternsLengths.length}")
                b-icon(icon="music-note")
                span Stress patterns
              a.card-header-icon
                b-icon(
                icon="arrow-drop-down"
                )


            .card-content
              .content

                div(v-for="groupNb in intonationGroups" :key="groupNb")
                  button.is-size-7.mb-1.has-text-left.button.w-100.py-1(
                    @click="toggleIntonationGroup(groupNb)"
                    :disabled="activeSyllables[0] && activeSyllables.indexOf(groupNb+'') === -1"
                    )
                    span
                      | {{groupNb}}
                      |
                      | syllables
                    b-icon.pl-1(:icon="displayIntonationGroup[groupNb] ?  'expand-more' : 'chevron-right'" custom-size="18px")

                  .is-flex.has-text-right.mb-1.has-flex-wrap.has-sb(v-if="displayIntonationGroup[groupNb]")
                    button.button.is-narrow.is-small.mb-1.w-100(
                    :class="{'is-info': filters.stressPatterns[int]}"
                    v-if="int.split('').length === groupNb"
                    @click="toggleDeep('stressPatterns', int)"
                    v-for="int in stressPatterns"
                    )
                      span(v-for="nb in int.split('')" :class="['is-int-'+nb]")
                        |{{ nb == '0' ? '•' : (nb == 1) ? '●' : '●' }}


        // SYLLABLES
        .column.has-flex-wrap.is-12-mobile
          b-dropdown.card.w-100(
            :hoverable="hoverable"
            :open="false"
          )
            .card-header(
            slot="trigger"
            )
              p.card-header-title(:class="{'has-text-info': activeSyllables.length}")
                b-icon(icon="line-weight")
                span Syllable count
              a.card-header-icon
                b-icon(
                icon="arrow-drop-down"
                )

            .card-content
              .content
                .is-flex.has-flex-wrap
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['1']}"
                  :disabled="!!stressPatternsLengths.length"
                  @click="toggleDeep('syllables', '1')"
                  ) 1
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['2']}"
                  :disabled="!!stressPatternsLengths.length && stressPatternsLengths.indexOf(2) === -1"
                  @click="toggleDeep('syllables', '2')"
                  ) 2
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['3']}"
                  :disabled="!!stressPatternsLengths.length && stressPatternsLengths.indexOf(3) === -1"
                  @click="toggleDeep('syllables', '3')"
                  ) 3
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['4']}"
                  :disabled="!!stressPatternsLengths.length"
                  @click="toggleDeep('syllables', '4')"
                  ) 4
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['5']}"
                  :disabled="!!stressPatternsLengths.length"
                  @click="toggleDeep('syllables', '5')"
                  ) 5
                  button.button.is-narrow.is-small.ml-1.mb-1(
                  :class="{'is-info': filters.syllables['6']}"
                  :disabled="!!stressPatternsLengths.length"
                  @click="toggleDeep('syllables', '6')"
                  ) 6

        // VIDEO
        .column.has-flex-wrap.is-12-mobile
          b-dropdown.card.w-100(
          :hoverable="hoverable"
          :open="false"
          )
            .card-header(
            slot="trigger"
            )
              p.card-header-title(:class="{'has-text-info': activeVideos.length}")
                b-icon(icon="videocam")
                span Video examples
              a.card-header-icon
                b-icon(
                icon="arrow-drop-down"
                )

            .card-content
              .content
                .is-flex.has-flex-wrap
                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                    @click="allWithVideo()"
                    )
                    b-icon(icon="videocam")
                    span All with video
                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                    :class="{'is-info': filters.videos['without']}"
                    @click="allWithoutVideo()"
                    )
                      b-icon(icon="videocam-off")
                      span All without video

                  span.w-100.pb-2
                    | or

                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                  :class="{'is-info': filters.videos['music']}"
                  @click="setDeep('videos', 'without', false);toggleDeep('videos', 'music')"
                  )
                   b-icon(icon="music-video")
                   span Music
                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                  :class="{'is-info': filters.videos['movie']}"
                  @click="setDeep('videos', 'without', false);toggleDeep('videos', 'movie')"
                  )
                    b-icon(icon="movie")
                    span Movie scenes
                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                  :class="{'is-info': filters.videos['tv_show']}"
                  @click="setDeep('videos', 'without', false);toggleDeep('videos', 'tv_show')"
                  )
                    b-icon(icon="tv")
                    span TV shows
                  button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(
                    :class="{'is-info': filters.videos['other']}"
                    @click="setDeep('videos', 'without', false);toggleDeep('videos', 'other')"
                    )
                    b-icon(icon="videocam")
                    span Other

                  <!--button.button.is-fullwidth.is-small.ml-1.mb-1.has-justified-start.pl-3(-->
                    <!--:class="{'is-info': filters.videos['without']}"-->
                    <!--@click="toggleDeep('videos', 'without')"-->
                    <!--)-->
                    <!--b-icon(icon="videocam-off")-->
                    <!--span Without video-->

      .has-text-right
        button.button(@click="reset")
          | Reset


</template>

<script>
  import { nodeApi } from "@/config";
  import _ from "lodash";
  import {mapGetters} from 'vuex'

  export default {
    name: "Filters",
    components: {
    },
    computed: {
      ...mapGetters(['display', 'filters', 'words']),
      stressPatterns() {
        // return _.filter(_.uniq(_.flatten(_.map(this.words, (line) => (line.i || "").split('|')))), (item) => item.length <= 3 && item.length >= 2).sort();
        return _.filter(_.uniq(_.flatten(_.map(this.words, (line) => (line.i || "").split('|')))), (item) => item.length >= 1).sort();
      },
      stressPatternsLengths() {
        return _.map(_.keys(_.pickBy(this.filters.stressPatterns)), item => item.length);
      },
      activePhonemes() {
        return _.keys(_.pickBy(this.filters.phonemes));
      },
      activeSyllables() {
        return _.keys(_.pickBy(this.filters.syllables));
      },
      activeVideos() {
        return _.keys(_.pickBy(this.filters.videos));
      },
      activePos() {
        return _.keys(_.pickBy(this.filters.pos));
      },
    },
    data() {
      return {
        dropdowns: {
          pos: false,
          pos: false,
          pos: false,
          pos: false,
          pos: false,
        },
        hoverable: true,
        search: null,
        intonationGroups: [2, 3, 4, 5, 6],
        displayIntonationGroup: {
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
        },
        // stressPatterns: [],
        pos: {
          fw: 'Function word',
          v: 'Verb',
          r: 'Adverb',
          n: 'Noun',
          j: 'Adjective',
          u: 'Interjection',
          m: 'Number',
          K: 'Proper noun',
          abbr: 'Abbreviation',
        },
        phonemes: {
          consonants: [
            'b',
            'd',
            'f',
            'ɡ',
            'h',
            'dʒ',
            'k',
            'l',
            'm',
            'n',
            'p',
            'r',
            's',
            't',
            'v',
            'w',
            'z',
            'ʒ',
            'tʃ',
            'ʃ',
            'θ',
            'ð',
            'ŋ',
            'ɹ',
            'ɫ',
            'j'
          ],
          simple_vowels: [
            'æ',
            'e',
            'i',
            'ɪ',
            'ɒ',
            'ʊ',
            'u',
            'ə',
            'ɑ',
            'ɛ',
            'ɝ',
            'ɔ',
            // 'eə',
            // 'ɪə',
            // 'ʊə',
          ],
          diphthongs_vowels: [
            'eɪ',
            'aɪ',
            'oʊ',
            'ɔɪ',
            'aʊ',
          ]
        }
      };
    },
    mounted () {
      if (this.$route.query.q) {
        this.search = this.$route.query.q;
        this.trottledSearch()
      }
    },
    created() {
      this.hoverable = !this.isMobile();
    },
    methods: {
      toggleIntonationGroup(group) {
        for (const i in this.displayIntonationGroup) {
          if (i != group) {
            this.displayIntonationGroup[i] = false;
          }
        }
        this.displayIntonationGroup[group] = !this.displayIntonationGroup[group];
      },
      isMobile() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1 || (navigator.userAgent.indexOf('iPhone') !== -1));
      },
      // togglePos(short) {
      //   const newPos = {
      //     pos: {
      //       ...this.filters.pos,
      //     }
      //   }
      //   newPos[short] = !newPos[short];
      //
      //   this.$store.dispatch('editFilters', newPos)
      // }
      allWithoutVideo() {
        this.setDeep('videos', 'music', false);
        this.setDeep('videos', 'movie', false);
        this.setDeep('videos', 'tv_show', false);
        this.setDeep('videos', 'other', false);
        this.setDeep('videos', 'without', true);
      },
      allWithVideo() {
        this.setDeep('videos', 'music', true);
        this.setDeep('videos', 'movie', true);
        this.setDeep('videos', 'tv_show', true);
        this.setDeep('videos', 'other', true);
        this.setDeep('videos', 'without', false);
      },
      setDeep(filterName, filterSubName, val) {
        const change = {
          filterName,
          filterSubName,
          filterData: val
        }
        this.$store.commit('editOneFilter', change)
      },
      toggleDeep(filterName, filterSubName) {
        const change = {
          filterName,
          filterSubName,
          filterData: !this.filters[filterName][filterSubName]
        }
        this.$store.commit('editOneFilter', change)
      },
      toggle(filterName) {
        const change = {
          filterName,
          filterData: !this.filters[filterName]
        }
        this.$store.commit('editOneFilter', change)
      },
      trottledSearch: _.throttle(function() {
        const change = {
          filterName: 'search',
          filterData: this.search
        }
        this.$store.commit('editOneFilter', change)
      }, 400),
      reset(){
        this.search = null;
        this.$store.commit('resetFilters')
      },
      toggleFilter() {
        this.$store.commit('editDisplay', {...this.display, filters: !this.display.filters})
      },
    }
  };
</script>

<style lang="scss">
  @import "colors";

  .slide-leave-active {
    transition-duration: 0.2s;
  }

  .slide-enter-active {
    transition-duration: 0.2s;
  }

  .filter-wrapper {
    /*transition: height .2s ease-in-out;*/
    &.is-inactive {
      height: 50px;
      overflow: hidden;
    }
    &.is-active {
      height: auto;
    }

    .stress-pattern .button {
      font-size: 0.8rem;
      display: flex;
      justify-content: space-around;
    }
  }


  .filter {

    .dropdown-trigger {
      width: 100%
    }
    .card-header-title,
    h4 {
      text-align: left;
      color: #7f8c8d;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 11px;
    }
  }
  .intonation-picker {
    span {
      vertical-align: middle;
      display: inline-block;
      line-height: 20px;
    }
  }

  .stress-pattern {
    .button {
      padding: 7px 9px;
      height: 27px;
      line-height: 12px;
      font-size: 0.5rem;
    }
    .is-int-0 { font-size: 0.9em; }
    .is-int-1 { font-size: 1.2em; }
    .is-int-2 { font-size: 1.9em; }
  }

  /*  MOBILE */

  @media screen and (max-width: 768px) {
    .filter-wrapper {
      margin-top: 3rem;
    }
  }

  @media screen and (max-width: 425px) {
    .filter-wrapper {
      margin-top: 40px;
      &.is-inactive {
        height: 50px;
        overflow: hidden;
      }
      &.is-active {
        height: auto;
      }
    }
    .c--id,
    li.th {
      display: none !important;
    }

  }





</style>



// WEBPACK FOOTER //
// src/components/Filters.vue